
import { useEffect, useState } from "react";

import './Footer.css'

const Footer = () => {
const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
    return (
        <>
       {showButton && (
        <button onClick={scrollToTop} className="back-to-top">
          ↑ Top
        </button>
      )}
            <div className='footer'>
                <div className="wrapper">
                    <div className="footer-content">
                        <div className="footer-text-1">
                            © 2026 Sherwood Public School. All Rights Reserved. | Concept & Design by eparivartan
                        </div>
                        <div className="footer-text-2">
                            <a href='/privacy-policy'>Privacy Policy</a>
                            &nbsp;|&nbsp;
                            <a href='/outdoor-learning-center'>Outdoor Learning Center</a>
                        </div>
                        <div className="footer-text-3">
                            <ul>
                                <li>
                                    <a href='https://www.instagram.com/sherwoodpublicschoolhyd/?hl=en' target="_blank">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.75 4.25H15.25M0.75 7.15C0.75 4.91 0.75 3.79 1.186 2.934C1.56949 2.18139 2.18139 1.56949 2.934 1.186C3.79 0.75 4.91 0.75 7.15 0.75H12.35C14.59 0.75 15.71 0.75 16.566 1.186C17.3186 1.56949 17.9305 2.18139 18.314 2.934C18.75 3.79 18.75 4.91 18.75 7.15V12.35C18.75 14.59 18.75 15.71 18.314 16.566C17.9305 17.3186 17.3186 17.9305 16.566 18.314C15.71 18.75 14.59 18.75 12.35 18.75H7.15C4.91 18.75 3.79 18.75 2.934 18.314C2.18139 17.9305 1.56949 17.3186 1.186 16.566C0.75 15.71 0.75 14.59 0.75 12.35V7.15Z" stroke="#F9F9F1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M13.212 9.23707C13.2793 9.69177 13.2565 10.1553 13.1447 10.6012C13.0329 11.047 12.8344 11.4665 12.5606 11.8357C12.2867 12.2048 11.9428 12.5164 11.5484 12.7527C11.1541 12.9889 10.7172 13.1452 10.2625 13.2126C9.80775 13.2799 9.34424 13.2571 8.89837 13.1453C8.45249 13.0335 8.033 12.8351 7.66385 12.5612C6.91829 12.008 6.42301 11.1814 6.28696 10.2631C6.1509 9.34475 6.38522 8.41001 6.93835 7.66446C7.49149 6.9189 8.31814 6.42362 9.23646 6.28757C10.1548 6.15151 11.0895 6.38583 11.8351 6.93896C12.5806 7.4921 13.0759 8.31875 13.212 9.23707Z" stroke="#F9F9F1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.facebook.com/sherwoodpublicschoolhyd' target='_blank'>
                                        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.575 0.675049H7.87505C6.68157 0.675049 5.53698 1.14915 4.69307 1.99307C3.84915 2.83698 3.37505 3.98157 3.37505 5.17505V7.87505H0.675049V11.475H3.37505V18.675H6.97505V11.475H9.67505L10.575 7.87505H6.97505V5.17505C6.97505 4.93635 7.06987 4.70744 7.23865 4.53865C7.40744 4.36987 7.63635 4.27505 7.87505 4.27505H10.575V0.675049Z" stroke="#F9F9F1" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.youtube.com/@sherwoodpublicschoolhyd' target='_blank'>
                                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.75 7.8501L9.25 9.8501V5.8501L12.75 7.8501Z" fill="#F9F9F1" stroke="#F9F9F1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M0.75 8.558V7.142C0.75 4.247 0.75 2.799 1.655 1.868C2.561 0.936 3.987 0.896 6.838 0.815C8.188 0.777 9.568 0.75 10.75 0.75C11.932 0.75 13.311 0.777 14.662 0.815C17.513 0.896 18.939 0.936 19.844 1.868C20.749 2.8 20.75 4.248 20.75 7.142V8.557C20.75 11.453 20.75 12.9 19.845 13.832C18.939 14.763 17.514 14.804 14.662 14.884C13.312 14.923 11.932 14.95 10.75 14.95C9.568 14.95 8.189 14.923 6.838 14.884C3.987 14.804 2.561 14.764 1.655 13.832C0.749 12.9 0.75 11.452 0.75 8.558Z" stroke="#F9F9F1" stroke-width="1.5" />
                                        </svg>
                                    </a>
                                </li>
                            </ul>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Footer